import {Injectable} from '@angular/core';
import {TokenData} from '../../models/tokenSession/TokenData';
import {UserModel} from '../../models/user/user.model';
import {UserConfigModel} from "../../models/user/config/user-config.model";

@Injectable()
export class Globals {

	constructor() {
		this.userConfig = new UserConfigModel();
	}

	tokenData: TokenData;
	user: UserModel;
	userConfig: UserConfigModel;

	tokenDataLoaded(): boolean {
		return this.tokenData != null;
	}

	userLoaded(): boolean {
		return this.user != null;
	}

	static getEnvironment(): string {
		let environmentName = '';
		if(window.location.href.indexOf('localhost') > -1) {
			environmentName = 'LOCAL';
		}
		if (window.location.href.indexOf('dev.wings') > -1 || window.location.href.indexOf('wings-dev') > -1) {
			environmentName = 'DEV';
		}
		if (window.location.href.indexOf('qa.wings') > -1 || window.location.href.indexOf('wings-qa') > -1) {
			environmentName = 'QA';
		}
		if (window.location.href.indexOf('m.wings.ford') > -1) {
			environmentName = 'PROD';
		}

		return environmentName;
	}
}
